module.exports = __webpack_public_path__ + "img/arrow-blue.76ff83d.png";